import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { MangoButton } from '~/components/shared/MangoButton'

import { spacing } from '../constants/theme'
import { desktop } from '../styles'
import { Text } from './core'
import { FontStyle } from './core/Text'

export const MangoPlusAdsWrapper = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  padding: 64px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  background-color: var(--chakra-colors-bg-emphasized);
  background-size: cover;
  background-repeat: no-repeat;
  overflow: auto;

  &::-webkit-scrollbar {
    width: ${desktop.scrollbar}px;
    background-color: transparent;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: ${desktop.scrollbar}px;
    -webkit-box-shadow: inset 0px 4px 14px rgba(0, 0, 0, 0.1);
    background-color: var(--chakra-colors-bg-emphasized);
  }

  @media screen and (max-width: ${desktop.breakXL}px) {
    display: block;
    padding: 40px;
  }
`

export const AdsContentsWrapper = styled.div`
  width: 65%;
  padding-top: ${spacing.spacingXL};
  box-sizing: border-box;
  > p {
    margin-bottom: ${spacing.spacingXL};
  }
  > div {
    margin-top: ${spacing.spacingXXL};
  }
`

export const AdsTitleWrapper = styled.div`
  width: 100%;

  // space between "relevant" & "in"
  span:first-child {
    margin-right: ${spacing.spacingLG};
  }

  @media screen and (max-width: ${desktop.breakXL}px) {
    width: 100%;
  }
`

interface AdsTitleProps {
  color?: string
}

export const AdsTitle = styled.span<AdsTitleProps>`
  color: ${(props) =>
    props.color ? props.color : 'var(--chakra-colors-fg-default)'};
`

interface MangoPlusAdsProps {
  onUpgrade?: () => void
}

const MangoPlusAds: React.FC<MangoPlusAdsProps> = ({
  onUpgrade = () => {},
}) => {
  const { t } = useTranslation()
  return (
    <MangoPlusAdsWrapper>
      <AdsTitleWrapper>
        <Text
          fontStyle={FontStyle.SuperLarge}
          color="var(--chakra-colors-fg-default)"
        >
          <AdsTitle color="var(--chakra-colors-brand-emphasized)">
            {t('mangoPlusAds.stayRelevant', 'Stay relevant')}
          </AdsTitle>
          <AdsTitle>
            {t('mangoPlusAds.inTodaysWorld', "in today's world")}
          </AdsTitle>
        </Text>
        <AdsContentsWrapper>
          <Text
            fontStyle={FontStyle.Normal}
            color="var(--chakra-colors-fg-subtle)"
            text={t('mangoPlusAds.bodyHeading', "Who doesn't like texting?")}
            weight="bold"
          />
          <Text
            fontStyle={FontStyle.Normal}
            color="var(--chakra-colors-fg-subtle)"
            text={t(
              'mangoPlusAds.paragraph1',
              "In today's world, people love texting over phone calls. Choose to text your customers-save time and energy!",
            )}
          />
          <Text
            fontStyle={FontStyle.Normal}
            color="var(--chakra-colors-fg-subtle)"
            text={t(
              'mangoPlusAds.paragraph2',
              'Texting is just one of the many Mango Plus perks. Talk to our Sales Team about a month trial before you buy.',
            )}
          />
          <MangoButton onClick={onUpgrade}>
            {t('mangoPlusAds.learnMore', 'Learn More')}
          </MangoButton>
        </AdsContentsWrapper>
      </AdsTitleWrapper>
    </MangoPlusAdsWrapper>
  )
}

export default MangoPlusAds
